// AUTO GENERATED FILE - Changes WILL be lost.
// fi - used as 'fi' fallback
export const common_fallback = true

export const translations = {
  "betslip.title": "Vetokuponki",
  "product.last60-row-single": "NBA:n viimeinen 60 yksittäisottelu",
  "product.sb-english-single": "Englannin jalkapallon yksinottelu",
  "product.sb-italian-single": "Italian Soccerbet-yksittäisottelu",
  "product.sb-greek-single": "Kreikan jalkapallon yksinottelu",
  "product.sb-english-league": "Englannin jalkapalloliiga",
  "product.sb-italian-league": "Italian jalkapalloliiga",
  "product.sb-greek-league": "Kreikan jalkapalloliiga",
  "last60.fixture.pending": "{visitor} {'@'} {home}",
  "last60.fixture.result": "{visitor} ({visitorScore}) {'@'} ({homeScore}) {home}",
  "sb.fixture.pending": "{home} VS. {away}",
  "sb.fixture.result": "{home} {homeScore} - {awayScore} {away}",
  "betslip.bet": "Aseta veto",
  "betslip.clear": "Tyhjennä",
  "betslip.clearResult": "Asia selvä",
  "betslip.noSelections": "Lisää valintoja aloittaaksesi vedonlyönnin",
  "betslip.notLoggedIn": "Kirjaudu sisään aloittaaksesi vedonlyönnin",
  "betslip.refresh": "virkistää",
  "betslip.totalStake": "Kokonaispanos",
  "betslip.noHistoryData": "Vedonlyöntitietoja ei ole saatavilla",
  "betslip.openBets": "Avaa vedot",
  "betslip.betHistory": "Vedonlyöntihistoria",
  "betslip.betHistoryWon": "Voitti",
  "betslip.betHistoryLost": "Kadonnut",
  "loading.loading": "Ladataan",
  "loading.account": "Ladataan tiliä",
  "loading.league": "Ladataan liigaa",
  "loading.gameweeks": "Peliviikkoja ladataan",
  "loading.markets": "Ladataan markkinoita",
  "loading.bethistory": "Ladataan vetohistoriaa",
  "login.loginRequired": "Sisäänkirjautuminen vaaditaan",
  "login.loginToBet": "Ole hyvä ja kirjaudu sisään aloittaaksesi vedonlyönnin",
  "navigation.back": "Takaisin",
  "navigation.close": "kiinni",
  "video.liveStreamAvailable": "Suora lähetys saatavilla",
  "video.logInToWatch": "Kirjaudu sisään katsoaksesi",
  "error.error": "Virhe",
  "error.404": "Sivua ei löydetty",
  "error.gameLaunchFailed": "Peliä ei voi käynnistää",
  "error.unknownErrorCode": "Tuntematon virhe: {code}",
  "error.minUnitStakeLimitExceeded": "Minimipanos on {limit}",
  "error.maxUnitStakeLimitExceeded": "Maksimipanos on {limit}",
  "error.minTotalStakeLimitExceeded": "Pienin kokonaispanos on {limit}",
  "error.maxTotalStakeLimitExceeded": "Suurin kokonaispanos on {limit}",
  "error.stakeInvalidMultiple": "Panoksen on oltava {multiple}:n kerrannainen",
  "error.notPlaced": "Ei sijoitettu",
  "error.wagerDisallowed": "Vedonlyönti kielletty",
  "error.errorEventIsOff": "Tapahtuma on alkanut",
  "wagerType.Singles": "Sinkkuja",
  "wagerType.Doubles": "Tuplaa",
  "wagerType.Trebles": "Diskantit",
  "wagerType.Accumulator": "Akku",
  "wagerType.Perm 4-Folds": "Perm 4-taitto",
  "wagerType.Perm 5-Folds": "Perm 5-taitto",
  "wagerType.Perm 6-Folds": "Perm 6-taitto",
  "wagerType.Perm 7-Folds": "Perm 7-taitto",
  "wagerType.Perm 8-Folds": "Perm 8-taitto",
  "wagerType.Perm 9-Folds": "Perm 9-taitto",
  "error.excess_bets": "Maksimi {limit} samanaikainen panos vetokupongilla; poista veto",
  "product.sb-turkish-league": "Turkin jalkapalloliiga",
  "error.minBetslipLimitExceeded": "Vetokupongin minimipanos on {limit}",
  "error.maxBetslipLimitExceeded": "Vetokupongin maksimipanos on {limit}",
  "error.exceededMaxPayout": "Suurin mahdollinen maksu on {limit}; pienennä panostasi",
  "betslip.potentialReturns": "Mahdolliset palautukset",
  "betslip.taxDisclaimer": "Kaikki nettovoittosi verotetaan vedonlyönnissä. Veron määrä lasketaan vedon mahdollisten voittojen mukaan.",
  "error.maintenanceEnabled": "Palvelin on parhaillaan huollossa",
  "error.internalError": "Sisäinen virhe",
  "error.invalidSession": "Istunto on virheellinen",
  "error.accountDisabled": "Tili on poistettu käytöstä",
  "error.invalidPlayerID": "Virheellinen pelaajatunnus",
  "error.insufficientBalance": "Riittämätön tasapaino",
  "error.configError": "Määritysvirhe",
  "error.betPlaceFailed": "Vedon asettaminen epäonnistui",
  "error.invalidProductID": "Virheellinen tuotetunnus",
  "error.playerReachedGamingLimits": "Pelaaja saavutti vastuullisen pelaamisen rajat",
  "error.gameCycleDoesNotExist": "Pelisykliä ei ole olemassa",
  "error.betAmountLimitExceeded": "Vahvistamattomien pelaajien mahdollinen voittoraja ylitetty",
  "betslip.netStake": "Nettopanos",
  "betslip.tax": "Verottaa",
  "error.badReturns": "Mahdollinen tuotto on pienempi kuin bruttopanos",
  "betslip.taxDisclaimerPoland": "Voitoista vähennetään 10 % yli 2 280 PLN:n summasta.",
  "error.incompatibleVersion": "Sovelluksen versio ei ole tuettu. Päivitä.",
  "product.iihf-row-single": "IIHF maailmanmestaruuskilpailut",
  "iihf.fixture.pending": "{home} VS. {away}",
  "iihf.fixture.result": "{home} {homeScore} - {awayScore} {away}",
  "ui.returnToPlayer": "Palaa pelaajalle",
  "abbr.ui.returnToPlayer": "RTP",
  "ui.averageReturnToPlayer": "Tämän pelin keskimääräinen RTP on {limit}",
  "error.betslipContainsInvalidOptions": "Vetokuponki sisältää virheellisiä vaihtoehtoja punaisella",
  "product.sb-scottish-single": "Scottish Soccerbet -yksittäisottelu",
  "product.sb-spanish-single": "Espanjan jalkapallon yksinottelu",
  "product.sb-spanish-league": "Espanjan Soccerbet League",
  "sb-english.team.ARS": "ARS",
  "sb-english.team.AST": "AST",
  "sb-english.team.BHA": "BHA",
  "sb-english.team.BOU": "BOU",
  "sb-english.team.BUR": "BUR",
  "sb-english.team.CHE": "CHE",
  "sb-english.team.CRY": "CRY",
  "sb-english.team.EVE": "EVE",
  "sb-english.team.LEI": "LEI",
  "sb-english.team.LIV": "LIV",
  "sb-english.team.MNC": "MNC",
  "sb-english.team.MNU": "MNU",
  "sb-english.team.NEW": "NEW",
  "sb-english.team.SOU": "SOU",
  "sb-english.team.TOT": "TOT",
  "sb-english.team.WAT": "WAT",
  "sb-english.team.WHU": "WHU",
  "sb-english.team.WOL": "WOL",
  "sb-english.team.NOR": "NOR",
  "sb-english.team.SHU": "SHU",
  "sb-english.team.LEE": "LEE",
  "sb-english.team.FUL": "FUL",
  "sb-english.team.WBA": "WBA",
  "sb-greek.team.AEK": "AEK",
  "sb-greek.team.APS": "APS",
  "sb-greek.team.ARI": "ARI",
  "sb-greek.team.AST": "AST",
  "sb-greek.team.ATR": "ATR",
  "sb-greek.team.GIA": "GIA",
  "sb-greek.team.LEV": "LEV",
  "sb-greek.team.OFI": "OFI",
  "sb-greek.team.OLM": "OLM",
  "sb-greek.team.PTK": "PTK",
  "sb-greek.team.PNS": "PNS",
  "sb-greek.team.PAO": "PAO",
  "sb-greek.team.PLT": "PLT",
  "sb-greek.team.XAN": "XAN",
  "sb-italian.team.MIL": "MIL",
  "sb-italian.team.ATA": "ATA",
  "sb-italian.team.BOL": "BOL",
  "sb-italian.team.BRE": "BRE",
  "sb-italian.team.CAG": "CAG",
  "sb-italian.team.CHI": "CHI",
  "sb-italian.team.FIO": "FIO",
  "sb-italian.team.GEN": "GEN",
  "sb-italian.team.INT": "INT",
  "sb-italian.team.JUV": "JUV",
  "sb-italian.team.LAZ": "LAZ",
  "sb-italian.team.NAP": "NAP",
  "sb-italian.team.ROM": "ROM",
  "sb-italian.team.SAM": "SAM",
  "sb-italian.team.UDI": "UDI",
  "sb-italian.team.VER": "VER",
  "nomorebets": "Ei enää vetoja",
  "playtime": "Peliaika",
  "gameId": "Pelin tunnus",
  "noGames": "Pelejä ei ole saatavilla. Tarkista pian uudelleen.",
  "Home": "Koti",
  "Away": "Pois",
  "Visitor": "Vierailija",
  "rules": "säännöt",
  "soccerbet.gameWeek": "PELIVIIKKO",
  "soccerbet.noGameWeeks": "Peliviikkoja ei ole tarjolla. Tarkista pian uudelleen.",
  "soccerbet.league": "Liigan sijoitukset",
  "soccerbet.table.name": "Nimi",
  "soccerbet.table.won": "W",
  "soccerbet.table.drawn": "D",
  "soccerbet.table.lost": "L",
  "soccerbet.table.points": "PT",
  "abbr.event.Both Teams To Score": "BTTS",
  "event.Both Teams To Score": "Molemmat joukkueet tekevät maalin",
  "event.Over / Under": "Yli alle",
  "event.Double Chance": "Kaksinkertainen mahdollisuus",
  "event.Match Result": "Ottelun tulos",
  "event.Exact Goals": "Tarkat tavoitteet",
  "event.Correct Score": "Oikea pistemäärä",
  "event.Match Result Both Score": "Ottelun tulos ja molemmat joukkueet tekevät maalin",
  "event.Result Und/Over 1.5 Total Goals": "Ottelun tulos ja yli/alle 1,5 maalia yhteensä",
  "event.Result Und/Over 2.5 Total Goals": "Ottelun tulos ja yli/alle 2,5 maalia yhteensä",
  "event.Under Over 1.5 Total Goals": "Yli/alle 1,5 maalia yhteensä",
  "event.Under Over 2.5 Total Goals": "Yli/alle 2,5 maalia yhteensä",
  "event.Under Over 3.5 Total Goals": "Yli/alle 3,5 maalia yhteensä",
  "event.Under Over 4.5 Total Goals": "Yli/alle 4,5 maalia yhteensä",
  "event.Total Goals 1 To 2": "Tavoitteet yhteensä 1-2",
  "event.Total Goals 1 To 3": "Tavoitteet yhteensä 1-3",
  "event.Total Goals 1 To 4": "Tavoitteet yhteensä 1-4",
  "event.Total Goals 2 To 3": "Tavoitteet yhteensä 2-3",
  "event.Total Goals 2 To 4": "Tavoitteet yhteensä 2-4",
  "event.Under Over 1.5 Home Goals": "Yli/alle 1,5 kotijoukkueen maalia",
  "event.Under Over 1.5 Away Goals": "Yli/alle 1,5 vierasjoukkueen maalia",
  "event.Home Team Exact Goals": "Kotijoukkueen tarkat maalit",
  "event.Away Team Exact Goals": "Vierasjoukkueen tarkat maalit",
  "event.Home Team To Score": "Kotijoukkue tekee maalin",
  "event.Away Team To Score": "Vierasjoukkue tekee maalin",
  "selection.Yes": "Joo",
  "selection.No": "Ei",
  "selection.1+G": "1+G",
  "selection.1+Ng": "1+Ng",
  "selection.X+G": "X+G",
  "selection.X+Ng": "X+Ng",
  "selection.2+G": "2+G",
  "selection.2+Ng": "2+Ng",
  "selection.1+Yes": "1+Kyllä",
  "selection.1+No": "1+Ei",
  "selection.X+Yes": "X+Kyllä",
  "selection.X+No": "X+Ei",
  "selection.2+Yes": "2+Kyllä",
  "selection.2+No": "2+Ei",
  "selection.TID_ANY_GOAL_SCORED_YES": "G",
  "selection.TID_ANY_GOAL_SCORED_NO": "Ng",
  "selection.U": "U",
  "selection.O": "O",
  "selection.1+O": "1+O",
  "selection.X+O": "X+O",
  "selection.2+O": "2+O",
  "selection.1+U": "1+U",
  "selection.X+U": "X+U",
  "selection.2+U": "2+U",
  "selection.TID_HOME_WIN": "1",
  "selection.TID_AWAY_WIN": "2",
  "selection.TID_DRAW": "X",
  "selection.TID_HOME_WIN_OR_DRAW": "1x",
  "selection.TID_DRAW_OR_AWAY_WIN": "x2",
  "selection.TID_HOME_OR_AWAY_WIN": "12",
  "selection.Over": "YLI",
  "selection.Under": "ALLA",
  "abbr.sb-english.team.ARS": "ARS",
  "abbr.sb-english.team.AST": "AST",
  "abbr.sb-english.team.BHA": "BHA",
  "abbr.sb-english.team.BOU": "BOU",
  "abbr.sb-english.team.BUR": "BUR",
  "abbr.sb-english.team.CHE": "CHE",
  "abbr.sb-english.team.CRY": "CRY",
  "abbr.sb-english.team.EVE": "EVE",
  "abbr.sb-english.team.LEI": "LEI",
  "abbr.sb-english.team.LIV": "LIV",
  "abbr.sb-english.team.MNC": "MNC",
  "abbr.sb-english.team.MNU": "MNU",
  "abbr.sb-english.team.NEW": "NEW",
  "abbr.sb-english.team.SOU": "SOU",
  "abbr.sb-english.team.TOT": "TOT",
  "abbr.sb-english.team.WAT": "WAT",
  "abbr.sb-english.team.WHU": "WHU",
  "abbr.sb-english.team.WOL": "WOL",
  "abbr.sb-english.team.NOR": "NOR",
  "abbr.sb-english.team.SHU": "SHU",
  "abbr.sb-english.team.LEE": "LEE",
  "abbr.sb-english.team.FUL": "FUL",
  "abbr.sb-english.team.WBA": "WBA",
  "abbr.sb-italian.team.MIL": "MIL",
  "abbr.sb-italian.team.ATA": "ATA",
  "abbr.sb-italian.team.BOL": "BOL",
  "abbr.sb-italian.team.BRE": "BRE",
  "abbr.sb-italian.team.CAG": "CAG",
  "abbr.sb-italian.team.CHI": "CHI",
  "abbr.sb-italian.team.FIO": "FIO",
  "abbr.sb-italian.team.GEN": "GEN",
  "abbr.sb-italian.team.INT": "INT",
  "abbr.sb-italian.team.JUV": "JUV",
  "abbr.sb-italian.team.LAZ": "LAZ",
  "abbr.sb-italian.team.NAP": "NAP",
  "abbr.sb-italian.team.ROM": "ROM",
  "abbr.sb-italian.team.SAM": "SAM",
  "abbr.sb-italian.team.UDI": "UDI",
  "abbr.sb-italian.team.VER": "VER",
  "abbr.sb-greek.team.AEK": "AEK",
  "abbr.sb-greek.team.APS": "APS",
  "abbr.sb-greek.team.ARI": "ARI",
  "abbr.sb-greek.team.AST": "AST",
  "abbr.sb-greek.team.ATR": "ATR",
  "abbr.sb-greek.team.GIA": "GIA",
  "abbr.sb-greek.team.LEV": "LEV",
  "abbr.sb-greek.team.OFI": "OFI",
  "abbr.sb-greek.team.OLM": "OLM",
  "abbr.sb-greek.team.PTK": "PTK",
  "abbr.sb-greek.team.PNS": "PNS",
  "abbr.sb-greek.team.PAO": "PAO",
  "abbr.sb-greek.team.PLT": "PLT",
  "abbr.sb-greek.team.XAN": "XAN",
  "sb-turkish.team.AKB": "AKHİSARSPOR",
  "sb-turkish.team.BES": "BEŞIKTAŞ",
  "sb-turkish.team.FEN": "FENERBAHÇE",
  "sb-turkish.team.GAL": "GALATASARAY",
  "sb-turkish.team.TRA": "TRABZONSPOR",
  "sb-turkish.team.ANT": "ANTALYASPOR",
  "sb-turkish.team.GEN": "GENÇLERBİRLİĞİ",
  "sb-turkish.team.KAS": "KASIMPAŞA",
  "sb-turkish.team.BUR": "BURSASPOR",
  "sb-turkish.team.KAY": "KAYSERİSPOR",
  "sb-turkish.team.SIV": "SİVASSPOR",
  "sb-turkish.team.IBA": "İSTANBUL BAŞAKŞEHIR",
  "sb-turkish.team.HAT": "HATAYSPOR",
  "sb-turkish.team.ADS": "AD. DEMIRSPOR",
  "sb-turkish.team.ALT": "ALTAY",
  "sb-turkish.team.GAZ": "GAZIANTEP",
  "sb-turkish.team.GOZ": "GÖZTEPE",
  "sb-turkish.team.KON": "KONYASPOR",
  "sb-turkish.team.CRS": "Ç. RIZESPOR",
  "sb-turkish.team.ALS": "ALANYASPOR",
  "abbr.sb-turkish.team.AKB": "AKB",
  "abbr.sb-turkish.team.BES": "BES",
  "abbr.sb-turkish.team.FEN": "FEN",
  "abbr.sb-turkish.team.GAL": "GAL",
  "abbr.sb-turkish.team.TRA": "TRA",
  "abbr.sb-turkish.team.ANT": "ANT",
  "abbr.sb-turkish.team.GEN": "GEN",
  "abbr.sb-turkish.team.KAS": "KAS",
  "abbr.sb-turkish.team.BUR": "BUR",
  "abbr.sb-turkish.team.KAY": "KAY",
  "abbr.sb-turkish.team.SIV": "SIV",
  "abbr.sb-turkish.team.IBA": "IBA",
  "abbr.sb-turkish.team.HAT": "HAT",
  "abbr.sb-turkish.team.ADS": "ADS",
  "abbr.sb-turkish.team.ALT": "ALT",
  "abbr.sb-turkish.team.GAZ": "GAZ",
  "abbr.sb-turkish.team.GOZ": "GOZ",
  "abbr.sb-turkish.team.KON": "KON",
  "abbr.sb-turkish.team.CRS": "CRS",
  "abbr.sb-turkish.team.ALS": "ALS",
  "sb-english.team.BRE": "Brentford",
  "abbr.sb-english.team.BRE": "BRE",
  "sb-english.team.NOT": "Nottingham F.",
  "abbr.sb-english.team.NOT": "NOT",
  "sb-spanish.team.ALV": "Alaves",
  "sb-spanish.team.ATB": "Athletic Bilbao",
  "sb-spanish.team.ATM": "Atletico Madrid",
  "sb-spanish.team.FCB": "Barcelona",
  "sb-spanish.team.CAD": "Cadiz",
  "sb-spanish.team.CLV": "Celta Vigo",
  "sb-spanish.team.ESP": "Espanyol",
  "sb-spanish.team.GET": "Getafe",
  "sb-spanish.team.GIR": "Girona",
  "sb-spanish.team.GRA": "Granada",
  "sb-spanish.team.LAP": "Las Palmas",
  "sb-spanish.team.MAL": "Mallorca",
  "sb-spanish.team.OSA": "Osasuna",
  "sb-spanish.team.RAY": "Rayo Vallecano",
  "sb-spanish.team.BET": "Real Betis",
  "sb-spanish.team.MAD": "Real Madrid",
  "sb-spanish.team.SOC": "Real Scoiedad",
  "sb-spanish.team.SEV": "Sevilla",
  "sb-spanish.team.VAL": "Valencia",
  "sb-spanish.team.VIL": "Villarreal",
  "abbr.sb-spanish.team.ALV": "ALV",
  "abbr.sb-spanish.team.ATB": "ATB",
  "abbr.sb-spanish.team.ATM": "ATM",
  "abbr.sb-spanish.team.FCB": "FCB",
  "abbr.sb-spanish.team.CAD": "CAD",
  "abbr.sb-spanish.team.CLV": "CLV",
  "abbr.sb-spanish.team.ESP": "ESP",
  "abbr.sb-spanish.team.GET": "GET",
  "abbr.sb-spanish.team.GIR": "GIR",
  "abbr.sb-spanish.team.GRA": "GRA",
  "abbr.sb-spanish.team.LAP": "LAP",
  "abbr.sb-spanish.team.MAL": "MAL",
  "abbr.sb-spanish.team.OSA": "OSA",
  "abbr.sb-spanish.team.RAY": "RAY",
  "abbr.sb-spanish.team.BET": "BET",
  "abbr.sb-spanish.team.MAD": "MAD",
  "abbr.sb-spanish.team.SOC": "SOC",
  "abbr.sb-spanish.team.SEV": "SEV",
  "abbr.sb-spanish.team.VAL": "VAL",
  "abbr.sb-spanish.team.VIL": "VIL",
  "sb-scottish.team.ABE": "Aberdeen",
  "sb-scottish.team.CEL": "Celtic",
  "sb-scottish.team.DDU": "Dundee United",
  "sb-scottish.team.HEA": "Sydämet",
  "sb-scottish.team.HIB": "Hiberian",
  "sb-scottish.team.KIL": "Kilmarnock",
  "sb-scottish.team.LIV": "Livingston",
  "sb-scottish.team.MOT": "Motherwell",
  "sb-scottish.team.RAN": "Rangers",
  "sb-scottish.team.STJ": "St Johnstone",
  "sb-scottish.team.STM": "St Mirren",
  "sb-scottish.team.DDE": "Dundee",
  "abbr.sb-scottish.team.ABE": "ABE",
  "abbr.sb-scottish.team.CEL": "CEL",
  "abbr.sb-scottish.team.DDU": "DDU",
  "abbr.sb-scottish.team.HEA": "HEA",
  "abbr.sb-scottish.team.HIB": "HIB",
  "abbr.sb-scottish.team.KIL": "KIL",
  "abbr.sb-scottish.team.LIV": "LIV",
  "abbr.sb-scottish.team.MOT": "MOT",
  "abbr.sb-scottish.team.RAN": "RAN",
  "abbr.sb-scottish.team.STJ": "STJ",
  "abbr.sb-scottish.team.STM": "STM",
  "abbr.sb-scottish.team.DDE": "DDE"
}
